// 客户档案
<template>
  <div class="customerInfo">
    <!-- <h3>客户档案信息</h3> -->
    <div class="topAddBtn clearfix">
      <div class="up_time">
        最后修改时间：<span>{{ up_time }}</span>
      </div>
      <el-button
        v-if="jurisdiction"
        size="mini"
        @click="openDialog(true)"
        style="float:right;"
        >编辑</el-button
      >
    </div>
    <!-- 对接人信息 -->
    <el-card shadow="hover" style="margin-bottom: 15px;">
      <div class="meetPerson clearfix">
        <h3>对接人信息</h3>
        <p>
          对接人：<span>{{ addFormData.meet_people }}</span>
        </p>
        <p>
          联系电话：<span>{{ addFormData.meet_phone }}</span>
        </p>
        <p>
          性别：<span>{{ addFormData.meet_gender }}</span>
        </p>
        <p>
          年龄：<span>{{ addFormData.meet_age }}</span>
        </p>
        <p>
          生日：<span>{{ addFormData.meet_birthday }}</span>
        </p>
        <p>
          职位：<span>{{ addFormData.meet_position }}</span>
        </p>
        <p>
          居住地：<span>{{ addFormData.meet_habitation }}</span>
        </p>
        <p>
          户籍：<span>{{ addFormData.meet_household_register }}</span>
        </p>
        <p>
          兴趣爱好：<span>{{ addFormData.meet_hobby }}</span>
        </p>
        <p>
          备注：<span>{{ addFormData.meet_remarks }}</span>
        </p>
      </div>
    </el-card>

    <!-- KP信息 -->
    <el-card shadow="hover">
      <div class="infoKP clearfix">
        <h3>KP信息</h3>
        <p>
          KP：<span>{{ addFormData.kp_people }}</span>
        </p>
        <p>
          联系电话：<span>{{ addFormData.kp_phone }}</span>
        </p>
        <p>
          性别：<span>{{ addFormData.kp_gender }}</span>
        </p>
        <p>
          年龄：<span>{{ addFormData.kp_age }}</span>
        </p>
        <p>
          生日：<span>{{ addFormData.kp_birthbay }}</span>
        </p>
        <p>
          职位：<span>{{ addFormData.kp_position }}</span>
        </p>
        <p>
          居住地：<span>{{ addFormData.kp_habitation }}</span>
        </p>
        <p>
          户籍：<span>{{ addFormData.kp_household_register }}</span>
        </p>
        <p>
          兴趣爱好：<span>{{ addFormData.kp_hobby }}</span>
        </p>
        <p>
          备注：<span>{{ addFormData.kp_remarks1 }}</span>
        </p>
      </div>
    </el-card>

    <!-- 添加客户档案对话框 -->
    <el-dialog
      title="编辑信息"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="addClose"
      append-to-body
    >
      <!-- 表单部分 -->
      <el-form
        :model="addFormData"
        :rules="custRules"
        ref="addFormData"
        label-width="80px"
        class="demo-ruleForm"
      >
        <h4>对接人部分</h4>
        <el-form-item label="姓名" class="formItems" prop="meet_people">
          <el-input v-model="addFormData.meet_people"></el-input>
        </el-form-item>

        <el-form-item label="电话" class="formItems" prop="meet_phone">
          <el-input
            v-model.number="addFormData.meet_phone"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="性别" class="formItems" prop="meet_gender">
          <el-input v-model="addFormData.meet_gender"></el-input>
        </el-form-item>

        <el-form-item label="年龄" class="formItems" prop="meet_age">
          <el-input v-model="addFormData.meet_age"></el-input>
        </el-form-item>

        <el-form-item label="生日" class="formItems">
          <el-input v-model="addFormData.meet_birthday"></el-input>
        </el-form-item>

        <el-form-item label="职位" class="formItems" prop="">
          <el-input v-model="addFormData.meet_position"></el-input>
        </el-form-item>

        <el-form-item label="居住地" prop="" class="formItems">
          <el-input v-model="addFormData.meet_habitation"></el-input>
        </el-form-item>

        <el-form-item label="户籍" class="formItems" prop="">
          <el-input v-model="addFormData.meet_household_register"></el-input>
        </el-form-item>

        <el-form-item label="爱好" prop="" class="formItems">
          <el-input v-model="addFormData.meet_hobby"></el-input>
        </el-form-item>

        <el-form-item label="备注" class="formItems" prop="">
          <el-input
            type="textarea"
            :rows="2"
            v-model="addFormData.meet_remarks"
          ></el-input>
        </el-form-item>

        <h4>KP部分</h4>
        <el-form-item label="KP姓名" class="formItems" prop="kp_people">
          <el-input v-model="addFormData.kp_people"></el-input>
        </el-form-item>

        <el-form-item label="电话" class="formItems" prop="kp_phone">
          <el-input v-model="addFormData.kp_phone"></el-input>
        </el-form-item>

        <el-form-item label="性别" class="formItems" prop="kp_gender">
          <el-input v-model="addFormData.kp_gender"></el-input>
        </el-form-item>

        <el-form-item label="年龄" class="formItems" prop="kp_age">
          <el-input v-model="addFormData.kp_age"></el-input>
        </el-form-item>

        <el-form-item label="生日" class="formItems">
          <el-input v-model="addFormData.kp_birthbay"></el-input>
        </el-form-item>

        <el-form-item label="职位" class="formItems" prop="">
          <el-input v-model="addFormData.kp_position"></el-input>
        </el-form-item>

        <el-form-item label="居住地" prop="" class="formItems">
          <el-input v-model="addFormData.kp_habitation"></el-input>
        </el-form-item>

        <el-form-item label="户籍" class="formItems" prop="">
          <el-input v-model="addFormData.kp_household_register"></el-input>
        </el-form-item>

        <el-form-item label="爱好" prop="" class="formItems">
          <el-input v-model="addFormData.kp_hobby"></el-input>
        </el-form-item>

        <el-form-item label="备注" class="formItems" prop="">
          <el-input
            type="textarea"
            :rows="2"
            v-model="addFormData.kp_remarks1"
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 弹出确认框 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTouchInfo('addFormData')"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from "@/libs/utils";
import api from "@/api";
export default {
  props: ["contractProp"],
  data() {
    return {
      // 表单信息
      dialogVisible: false, //新建对话框是否显示
      addFormData: {
        //对接人部分
        meet_people: "", //对接人
        meet_phone: "", //电话
        meet_gender: "", //性别
        meet_age: "",
        meet_birthday: "",
        meet_position: "",
        meet_habitation: "", //居住地
        meet_household_register: "", //户籍
        meet_hobby: "", //爱好
        meet_remarks: "", //备注
        // kp:'',
        // KP部分
        kp_people: "",
        kp_phone: "",
        kp_gender: "",
        kp_age: "",
        kp_birthbay: "",
        kp_position: "",
        kp_habitation: "",
        kp_household_register: "",
        kp_hobby: "",
        kp_remarks1: "",
      },
      custRules: {
        //验证规则
        meet_people: [
          { required: true, message: "请填写姓名", trigger: "change" },
        ],
        meet_gender: [
          { required: true, message: "请填写性别", trigger: "change" },
        ],
        meet_age: [
          // {trigger: 'change'},
          // {type: 'number', message: '请输入数字'}
        ],
        meet_phone: [
          { required: true, message: "请填写联系电话", trigger: "change" },
          { type: "number", message: "请输入数字" },
        ],
        kp_age: [
          // {trigger: 'change'},
          // {type: 'number', message: '请输入数字'}
        ],
        kp_phone: [
          // {trigger: 'change'},
          // {type: 'number', message: '请输入数字'}
        ],
        kp_people: [{ message: "请填写姓名", trigger: "change" }],
        kp_gender: [{ message: "请填写性别", trigger: "change" }],
      },
      c_id: "", //客户id
      up_time: "",
      userId: "", //当前登录人id
      // 权限
      jurisdiction: false, //修改客户档案权限 0 2 ：true     1：false
    };
  },
  created() {
    this.c_id = this.contractProp.customer_id;
    this.userId = utils.sessionGetStore("user_id");

    this.getData(this.c_id);

    // 获取权限
    let jur = utils.sessionGetStore("jurisdiction");
    this.jurisdiction = jur == "1" ? false : true;
  },

  methods: {
    // 获取信息
    getData(id) {
      api.getCustomerFiles(id).then((res) => {
        // console.log("档案",res)
        let objData = res.data.data.list;
        this.addFormData = objData;
        for (let key in this.addFormData) {
          if (this.addFormData[key] == "null") {
            this.addFormData[key] = "";
          }
        }
        // console.log(this.addFormData)

        // 年龄 和 电话 返回值为字符串，会被表单验证
        // if(objData.meet_age){ // 对接人
        //   this.addFormData.meet_age = Number(objData.meet_age)
        // }
        if (objData.meet_phone) {
          this.addFormData.meet_phone = Number(objData.meet_phone);
        }
        // if(objData.kp_age){ // KP
        //   this.addFormData.kp_age = Number(objData.kp_age)
        // }
        if (objData.kp_phone) {
          this.addFormData.kp_phone = Number(objData.kp_phone);
        }

        this.up_time = objData.up_time; // 最后修改时间
      });
    },

    // 添加 / 修改客户档案
    // 在点击对话框之外时，会弹出此对话框
    addClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 开启对话框
    openDialog(view) {
      this.dialogVisible = view;
    },
    //确认新建
    addTouchInfo(formName) {
      // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
          let paramObj = this.addFormData;
          paramObj.c_id = this.c_id;
          paramObj.up_user = this.userId;
          api
            .addCustomerFiles(paramObj)
            .then((res) => {
              utils.notificationInfo("提示", "操作成功", "success");
              this.getData(this.c_id);
            })
            .catch((err) => {
              console.log(err);
              utils.notificationInfo("提示", "操作失败", "error");
            });
        } else {
          console.log("error submit!!");
          utils.notificationInfo("提示", "操作失败", "error");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.customerInfo {
  position: relative;
  padding-bottom: 20px;
  .topAddBtn {
    padding: 10px 20px;
    // border-bottom: 4px solid #999;

    .up_time {
      float: left;
      font-size: 14px;
      > span {
        color: #999;
        font-size: 12px;
      }
    }
  }
  > h3 {
    font-size: 25px;
    margin: 10px 0;
    text-align: center;
  }

  .meetPerson,
  .infoKP {
    padding: 10px 30px;
    > h3 {
      font-size: 18px;
      // color:#04B991;
      color: #0f70ee;
      // color: #409EFF;
      margin-bottom: 10px;
      // text-align: center;
    }
    > p {
      float: left;
      width: 200px;
      font-size: 14px;
      margin: 10px;
      > span {
        font-size: 14px;
        color: #0f70ee;
        // color:#04B991;
        // color:#409EFF;
      }
    }
  }
}

// 表单
.demo-ruleForm {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  > h4 {
    font-size: 20px;
    width: 100%;
    text-align: center;
    // padding:20px 0;
    margin-bottom: 15px;
  }
  .formItems {
    width: 40%;
    // float: left;
    // margin-left:20px;
    // margin-right:20px;
  }
}
</style>
